import { createFilledIcon } from "../createIcon";

export const HomeFilledIcon = createFilledIcon(
  <>
    <path d="M5 21.5h4.152a.5.5 0 0 0 .5-.5v-4.887a1 1 0 0 1 1-1h2.696a1 1 0 0 1 1 1V21a.5.5 0 0 0 .5.5H19a2 2 0 0 0 2-2V9.685a2 2 0 0 0-.748-1.559l-7-5.62a2 2 0 0 0-2.504 0l-7 5.62A2 2 0 0 0 3 9.686V19.5a2 2 0 0 0 2 2Z" />
  </>,
  "HomeFilledIcon"
);
